'use client';

import { TEST_DURATIONS } from '@/lib/constants/site';

/**
 * Segmented duration selector for typing tests.
 * Uses radio group semantics for accessibility.
 *
 * @param {{ value: number, onChange: (n: number) => void, disabled?: boolean }} props
 */
export function DurationPicker({ value, onChange, disabled = false }) {
  return (
    <fieldset disabled={disabled} className="inline-flex rounded-md border border-border bg-surface-raised p-0.5">
      <legend className="sr-only">Test duration</legend>
      {TEST_DURATIONS.map((d) => (
        <label
          key={d}
          className={`cursor-pointer rounded-sm px-3 py-1.5 text-sm font-medium transition-colors has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-2 has-[:focus-visible]:outline-brand-500 ${
            value === d
              ? 'bg-brand-600 text-white'
              : 'text-text-secondary hover:text-text-primary'
          }`}
        >
          <input
            type="radio"
            name="duration"
            value={d}
            checked={value === d}
            onChange={() => onChange(d)}
            className="sr-only"
          />
          {d}s
        </label>
      ))}
    </fieldset>
  );
}